import { useRef, useState, useEffect } from 'react'

const useVisibleNotifications = <T>(
  notifications: T[] | undefined | null,
  isOpen: boolean,
) => {
  const containerRef = useRef<HTMLUListElement>(null)
  const [visibleCount, setVisibleCount] = useState<number | null>(null)

  const calculateVisibleItems = () => {
    if (!isOpen || !containerRef.current || !notifications?.length) return

    const container = containerRef.current
    const containerHeight = container.clientHeight

    if (containerHeight === 0) return

    const items = Array.from(container.children) as HTMLElement[]
    let accumulatedHeight = 0
    let count = 0

    for (const item of items) {
      const itemHeight = item.offsetHeight
      const potentialHeight = accumulatedHeight + itemHeight

      if (potentialHeight <= containerHeight) {
        accumulatedHeight = potentialHeight
        count++
      } else {
        break
      }
    }

    setVisibleCount(count)
  }

  useEffect(() => {
    if (!isOpen) return

    requestAnimationFrame(calculateVisibleItems)

    const resizeObserver = new ResizeObserver(calculateVisibleItems)
    if (containerRef.current) {
      resizeObserver.observe(containerRef.current)
    }

    return () => resizeObserver.disconnect()
  }, [notifications, isOpen])

  return {
    containerRef,
    visibleCount,
  }
}

export default useVisibleNotifications
